const REACT_WARNING_PATTERNS = [
  "function components cannot be given refs",
];
const ALWAYS_SUPPRESS_SIGNATURES = [
  "check the render method of `forwardref(themeprovider)`",
];

export function shouldDeduplicateReactWarning(message: string): boolean {
  const normalized = message.toLowerCase();
  if (!normalized.startsWith("warning:")) return false;
  return REACT_WARNING_PATTERNS.some((pattern) => normalized.includes(pattern));
}

export function createReactWarningDeduper(): (message: string) => boolean {
  const seen = new Set<string>();
  return (message: string): boolean => {
    if (!shouldDeduplicateReactWarning(message)) return false;
    const normalized = message.toLowerCase();
    if (ALWAYS_SUPPRESS_SIGNATURES.some((signature) => normalized.includes(signature))) {
      return true;
    }

    const key = message.split("\n")[0].trim().toLowerCase();
    if (seen.has(key)) return true;
    seen.add(key);
    return false;
  };
}
